import { render, staticRenderFns } from "./MainViewAuth.vue?vue&type=template&id=6204b91d&"
import script from "./MainViewAuth.vue?vue&type=script&lang=js&"
export * from "./MainViewAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports